import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import './mobile.css';
// import Footer from './Footer';

const Layout = ({ children }) => {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Routes where we don't want Navbar/Footer
    const noLayoutRoutes = ['/login', '/accept-invitation', "/track", "/integrations", "/contact"];

    const showLayout = !noLayoutRoutes.some(route =>
        location.pathname.includes(route)
    );

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-zinc-950">
            {showLayout && (
                <Navbar
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                />
            )}
            <main
                className={`app-main ${showLayout ? "app-main--authenticated" : ""} ${location.pathname.endsWith("/assignment/list") ? "app-main--jobs" : ""} fixed top-3.5 right-4 transition-all duration-300 ease-in-out ${showLayout
                    ? (isSidebarOpen
                        ? 'bottom-[4.5rem] md:bottom-3.5 left-3 md:left-[17rem]'
                        : 'bottom-[4.5rem] md:bottom-3.5 left-3 md:left-[5rem]')
                    : 'bottom-3.5 left-4'
                    }`}
            >
                <div className="app-scroll h-full overflow-y-auto bg-white dark:bg-zinc-800 rounded-xl shadow-lg">
                    {location.pathname.includes("/login") ?
                        children
                        :
                        <div className="app-shell flex flex-col min-h-full">
                            <div className={`app-page-wrapper w-full mx-auto sm:px-2 py-2 ${(location?.pathname?.includes("/track")) && "sm:px-0 py-0"}`}>
                                <div className={`app-page bg-white dark:bg-zinc-800 rounded-xl shadow-lg sm:px-8 px-4 py-8 space-y-8 ${(location?.pathname?.includes("/track")) && "sm:px-0 px-0 py-0 sm:py-0 space-y-0"}`}>
                                    {children}
                                </div>
                            </div>
                        </div>

                    }
                </div>
            </main>
            {/* {showLayout && <Footer />} */}
        </div>
    );
};

export default Layout;